/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const AdvancedOptions = defineMessages({
  title: {
    id: 'twilioMessaging.AdvancedOptions.title',
    defaultMessage: 'Advanced options'
  },
  subtitle: {
    id: 'twilioMessaging.AdvancedOptions.subtitle',
    defaultMessage:
      "Need help? <link>Learn more</link> about SMS's advanced options."
  },
  inbound: {
    id: 'twilioMessaging.AdvancedOptions.inbound',
    defaultMessage: 'Initiate conversation from inbound messages'
  },
  timeoutNotify: {
    id: 'twilioMessaging.AdvancedOptions.timeoutNotify',
    defaultMessage: 'Notify assistant on session timeout'
  },
  timeoutValue: {
    id: 'twilioMessaging.AdvancedOptions.timeoutValue',
    defaultMessage: 'Session timeout in seconds'
  },
  timeoutZero: {
    id: 'twilioMessaging.AdvancedOptions.timeoutZero',
    defaultMessage: 'If set to zero, session will never time out.'
  },
  errorReplyMessage: {
    id: 'twilioMessaging.AdvancedOptions.errorReplyMessage',
    defaultMessage: 'Default failure message'
  },
  selections: {
    id: 'twilioMessaging.AdvancedOptions.selections',
    defaultMessage: 'Selections'
  },
  defaultMessagingFailurePlaceholder: {
    id: 'twilioMessaging.AdvancedOptions.defaultMessagingFailurePlaceholder',
    defaultMessage:
      "For example: We're sorry, but we can't respond to your message"
  },
  defaultMessagingFailure: {
    id: 'twilioMessaging.AdvancedOptions.defaultMessagingFailure',
    defaultMessage: 'Unable to respond to the mobile message due to an error.'
  },
  defaultMessagingFailureRequired: {
    id: 'twilioMessaging.AdvancedOptions.defaultMessagingFailureRequired',
    defaultMessage: 'Default failure message is required'
  },
  urlLabel: {
    id: 'twilioMessaging.AdvancedOptions.urlLabel',
    defaultMessage: 'Base URL'
  },
  urlPlaceholder: {
    id: 'twilioMessaging.AdvancedOptions.urlPlaceholder',
    defaultMessage: 'For example: https://api.twilio.com'
  },
  urlDefault: {
    id: 'twilioMessaging.AdvancedOptions.urlDefault',
    defaultMessage: 'https://api.twilio.com'
  },
  urlError: {
    id: 'twilioMessaging.AdvancedOptions.urlError',
    defaultMessage: 'Base URL is not valid'
  },
  urlRequired: {
    id: 'twilioMessaging.AdvancedOptions.urlRequired',
    defaultMessage: 'A valid base URL is required'
  },
  defaultMessagingProviderType: {
    id: 'twilioMessaging.AdvancedOptions.defaultMessagingProviderType',
    defaultMessage: 'Twilio'
  }
});
